var _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonServiceable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89.191,
    cy: 96.559,
    r: 56.411,
    fill: "#F1F3FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.038,
    cy: 49.469,
    r: 3.536,
    fill: "#F1F3FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.314,
    cy: 33.911,
    r: 6.589,
    fill: "#F1F3FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.441,
    cy: 132.88,
    r: 6.268,
    fill: "#F1F3FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.734,
    cy: 113.304,
    r: 1.768,
    fill: "#F1F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.605 49c-.186-.04-.186-.306 0-.346l2.818-.6a.174.174 0 00.135-.134l.607-2.798c.04-.185.305-.185.345 0l.607 2.798c.014.067.068.12.135.135l2.818.599c.186.04.186.306 0 .345l-2.818.6a.176.176 0 00-.135.135l-.607 2.797c-.04.186-.305.186-.345 0l-.607-2.797a.174.174 0 00-.135-.136L98.605 49zM140.721 129.908c.064-.306.501-.306.565 0l.967 4.566c.024.112.11.199.221.223l4.52.985c.303.066.303.499 0 .565l-4.52.984a.292.292 0 00-.221.223l-.967 4.567c-.064.305-.501.305-.565 0l-.967-4.567a.292.292 0 00-.221-.223l-4.52-.984c-.303-.066-.303-.499 0-.565l4.52-.985a.289.289 0 00.221-.223l.967-4.566zM77.248 46.993c.05-.235.386-.235.436 0l.434 2.051a.223.223 0 00.17.172l2.037.444c.233.05.233.384 0 .435l-2.037.443a.222.222 0 00-.17.172l-.434 2.051c-.05.235-.386.235-.436 0l-.434-2.051a.223.223 0 00-.17-.172l-2.037-.443c-.233-.051-.233-.385 0-.435l2.037-.444a.223.223 0 00.17-.172l.434-2.05z",
    fill: "#C4CBF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.214 114.18c7.237-2.074 3.068-.597 7.28-2.183 3.181-1.871 6.465-3.594 10.348-4.468 3.298-.743 3.217-.649 6.829-.472 1.724.531 3.151 1.689 3.419 3.048.22 1.122-2.041 2.783-3.42 3.395-5.149 2.288-2.638 1.086-6.402 2.133-6.99 1.943-14.511 5.266-17.447 10.436-1.594 2.806-1.98 6.066-.587 8.647 1.952 3.614 7.937 6.618 13.882 6.099 2.383-.207 5.159-.66 7.446-1.368 2.418-.749 4.002-1.328 6.09-2.489 4.841-2.694 10.612-6.195 15.33-9",
    stroke: "#C4CBF5",
    strokeWidth: 1.402,
    strokeLinecap: "round",
    strokeDasharray: "2.8 2.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.101 41.295c18.371 1.683 31.899 17.94 30.216 36.31a33.532 33.532 0 01-1.245 6.492c-4.035 17.774-25.831 35.959-33.83 42.131-1.678 1.295-4.017 1.091-5.432-.487-6.095-6.796-21.531-25.334-24.964-42.298a33.33 33.33 0 01-1.055-11.931c1.683-18.371 17.94-31.9 36.31-30.217z",
    fill: "#E47278"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.726 75.719c.641-6.998-4.513-13.191-11.511-13.832-6.998-.641-13.191 4.512-13.832 11.51-.641 6.999 4.512 13.192 11.511 13.833 6.998.64 13.191-4.513 13.832-11.511z",
    fill: "#F1F3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.824 86.904v.021l.003.021c.384 3.716-.945 8.13-2.723 12.125-1.768 3.975-3.936 7.441-5.127 9.23a1.064 1.064 0 01-1.424.345c-1.69-.953-4.72-2.77-7.786-5.14-3.075-2.377-6.136-5.275-7.938-8.38l-.011-.019-.013-.018a13.658 13.658 0 01-1.977-4.493c-1.76-7.353 2.773-14.74 10.125-16.501 7.353-1.76 14.74 2.773 16.5 10.125.216.898.337 1.796.37 2.684z",
    fill: "#fff",
    stroke: "#C4CBF5",
    strokeWidth: 1.286
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.076 85.987a6.103 6.103 0 10-11.87 2.842 6.103 6.103 0 0011.87-2.842z",
    fill: "#F1F3FF",
    stroke: "#C4CBF5",
    strokeWidth: 1.286
  })));
}
export default SvgNonServiceable;